export default "__VITE_ASSET__BmShqMTm__"